import { describeSavedTaxId } from "@repo/components/src/forms/identifier/logic";
import { Badge, BadgeText } from "@repo/components/src/ui/badge";
import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { TaxProfileFragmentFragment } from "@repo/graphql/documents/fiscal/fragment.generated";

type Props = {
  taxProfile: TaxProfileFragmentFragment;
  countryCode: string;
  canEdit: boolean;
  onEdit: () => void;
};

export default function ConfirmedSummary({
  taxProfile,
  countryCode,
  canEdit,
  onEdit,
}: Props) {
  const taxId = describeSavedTaxId(taxProfile.taxId, countryCode);
  return (
    <VStack space="md">
      <HStack space="sm" className="items-center">
        <Badge action="success" size="sm" rounded="full">
          <BadgeText>Confirmada</BadgeText>
        </Badge>
      </HStack>
      <VStack space="xs">
        <Text size="xs" action="muted">
          {taxId.label}
        </Text>
        <Text size="sm">{taxId.value}</Text>
      </VStack>
      <VStack space="xs">
        <Text size="xs" action="muted">
          Razón social
        </Text>
        <Text size="sm">{taxProfile.legalName}</Text>
      </VStack>
      {taxProfile.regimeOption ? (
        <VStack space="xs">
          <Text size="xs" action="muted">
            Régimen tributario
          </Text>
          <Text size="sm">{taxProfile.regimeOption.label}</Text>
        </VStack>
      ) : null}
      {taxProfile.addressLine ? (
        <VStack space="xs">
          <Text size="xs" action="muted">
            Dirección
          </Text>
          <Text size="sm">{taxProfile.addressLine}</Text>
        </VStack>
      ) : null}
      {canEdit ? (
        <Box>
          <Button
            variant="link"
            action="brand"
            size="sm"
            className="w-fit"
            onPress={onEdit}
          >
            <ButtonText>Editar</ButtonText>
          </Button>
        </Box>
      ) : null}
    </VStack>
  );
}
